import React from 'react';
import { Result } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

const CustomerConfirmSuccess: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <Result
        icon={<CheckCircleFilled className="text-green-500 text-6xl" />}
        title="確認成功"
        subTitle="感謝您的確認。訂單變更已成功處理。"
        status="success"
      />
    </div>
  );
};

export default CustomerConfirmSuccess;
